import React, { useState } from "react";
import { formatarDataBrasil } from '../../utils/utils';
import "./SaldoAsaas.css";

export default function SaldoAsaas() {
  const [inicio, setInicio] = useState(() => {
    const hoje = new Date();
    return hoje.toISOString().split('T')[0];
  });

  const [fim, setFim] = useState(() => {
    const hoje = new Date();
    return hoje.toISOString().split('T')[0];
  });

  const [dados, setDados] = useState({
    saldo: 0,
    totalPendentes: 0,
    totalRecebidas: 0,
    totalRecebidasCount: 0,
    detalhesPendentes: [],
    detalhesRecebidas: []
  });

  const [loading, setLoading] = useState(false);
  const [verPendentes, setVerPendentes] = useState(false);
  const [verRecebidas, setVerRecebidas] = useState(false);

  const carregarDados = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({ inicio, fim });
      const response = await fetch(`https://welaunchyou.com.br/crm-wly/api/financeiro/saldo_asaas.php?${params}`);
      const data = await response.json();
      setDados(data);
    } catch (error) {
      console.error("Erro ao carregar dados do Asaas:", error);
    }
    setLoading(false);
  };

  return (
    <div className="asaas-titulo">
      <h2 style={{ borderBottom: "none" }}>Resumo Asaas</h2>
      <div className="asaas-container">
        <form
          className="asaas-filtro"
          onSubmit={(e) => {
            e.preventDefault();
            carregarDados();
          }}
        >
          <label>
            Início:
            <input type="date" value={inicio} onChange={(e) => setInicio(e.target.value)} />
          </label>
          <label>
            Fim:
            <input type="date" value={fim} onChange={(e) => setFim(e.target.value)} />
          </label>
          <button type="submit" className="asaas-btn-aplicar">Aplicar Filtro</button>
        </form>

        {loading ? (
          <p className="asaas-carregando">Carregando dados...</p>
        ) : (
          <div className="asaas-dados">
            <div className="asaas-card saldo">
              <h3><b>Saldo em Conta</b></h3>
              <p>Disponível: <strong>R$ {dados.saldo.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong></p>
            </div>

            <div className="asaas-card pendentes">
              <h3><b>Aguardando Pagamento</b></h3>
              <p>Total: <strong>R$ {dados.totalPendentes.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong></p>
              <button
                className="asaas-toggle"
                style={{ width: 150, marginLeft: 0 }}
                onClick={() => setVerPendentes(!verPendentes)}
              >
                {verPendentes ? 'Ocultar detalhes' : 'Ver detalhes'}
              </button>
              {verPendentes && (
                <div className="asaas-accordion-content active">
                  <table className="asaas-accordion-table leads-table2">
                    <thead>
                      <tr>
                        <th>Cliente</th>
                        <th>Vencimento</th>
                        <th>Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dados.detalhesPendentes.map((item, idx) => (
                        <tr key={idx}>
                          <td>{item.nome_cliente}</td>
                          <td>{formatarDataBrasil(item.vencimento)}</td>
                          <td>R$ {item.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div className="asaas-card recebidas">
              <h3><b>Confirmadas (Recebidas)</b></h3>
              <p>Total: <strong>R$ {dados.totalRecebidas.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</strong></p>
              <p>Quantidade: <strong>{dados.totalRecebidasCount} cobranças</strong></p>
              <button
                className="asaas-toggle"
                style={{ width: 150, marginLeft: 0 }}
                onClick={() => setVerRecebidas(!verRecebidas)}
              >
                {verRecebidas ? 'Ocultar detalhes' : 'Ver detalhes'}
              </button>
              {verRecebidas && (
                <div className="asaas-accordion-content active">
                  <table className="asaas-accordion-table leads-table2">
                    <thead>
                      <tr>
                        <th>Cliente</th>
                        <th>Vencimento</th>
                        <th>Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dados.detalhesRecebidas.map((item, idx) => (
                        <tr key={idx}>
                          <td>{item.nome_cliente}</td>
                          <td>{formatarDataBrasil(item.vencimento)}</td>
                          <td>R$ {item.valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
